import {
  ApiGetRequest,
  ApiPostRequest,
  ApiDeleteRequest,
  ApiPutRequest,
  ApiPostMultipart,
  ApiBlobGetRequest,
} from '../../api';
import { showNotif } from '../notification';
import moment from 'moment-mini';

export const state = {
  data: {
    title: 'Daftar Ijin Karyawan',
    breadcrumb: [
      {
        text: 'Dashboard',
        href: '/opr',
      },
      {
        text: 'Ijin Karyawan',
        href: '/adm/ijin-karyawan',
        active: true,
      },
    ],
    showmodal: false,
    items: [],
    totalRows: 0,
    page: 1,
    limit: 10,
    pageOptions: [10, 25, 50, 100],
    search: '',
    sortBy: 'id_ijin_karyawan',
    sortDesc: true,
    fields: [
      {
        key: 'no',
        label: 'No',
        thStyle: {
          width: '50px',
        },
      },
      // {
      //   key: 'kode_ijin',
      //   label: 'Kode',
      //   sortable: true,
      // },
      {
        key: 'nm_karyawan',
        label: 'Nama Karyawan',
        sortable: true,
      },
      {
        key: 'created_at',
        label: 'Tgl Transaksi',
        sortable: true,
      },
      {
        key: 'nm_dept',
        label: 'Dept',
      },
      {
        key: 'tgl_awal',
        label: 'Tgl Awal',
        sortable: true,
      },
      {
        key: 'tgl_akhir',
        label: 'Tgl Akhir',
        sortable: true,
      },
      {
        key: 'hari_ijin',
        label: 'Total Hari',
        sortable: true,
      },
      {
        key: 'jenis_ijin',
        label: 'Jenis Ijin',
        sortable: true,
      },
      {
        key: 'status_ijin',
        label: 'Status',
        sortable: true,
      },
      {
        key: 'aksi',
        thStyle: {
          textAlign: 'center',
        },
        label: 'Aksi',
      },
    ],
    detail: false,
    form: {
      dist_code: '',
      dist_company: '',
      dist_address: '',
      dist_email: '',
      dist_phone: '',
    },
    import_form: [],
  },
};

export const getters = {
  form(state) {
    return state.data.form;
  },
  import_form(state) {
    return state.data.import_form;
  },
};

export const mutations = {
  changeIjinKaryawan(state, data) {
    state.data = Object.assign({}, state.data, data);
  },
};

export const actions = {
  async searchIjinKaryawan(context, params = null) {
    let result = await ApiGetRequest(`ijin-karyawan`, params);
    return !result.error ? result.data.object : [];
  },

  async getTotalNotApproveIjin(context, params = null) {
    let result = await ApiGetRequest(`ijin-karyawan/not-approve`, params);
    return !result.error ? (result.data.object ? result.data.object : 0) : 0;
  },

  async getJenisIjin({ commit }) {
    commit('changeIjinKaryawan', {
      loading: true,
    });

    let result = await ApiGetRequest(`jenis-ijin`);
    commit('changeIjinKaryawan', {
      data_jenis_ijin: !result.error ? result.data.object : [],
      loading: false,
    });

    return !result.error ? true : false;
  },

  async getListIjinKaryawan({ commit, state }, payload = {}) {
    commit('changeIjinKaryawan', {
      loading: true,
    });

    const { data } = state;
    let params = {
      q: data.search,
      limit: data.limit,
      page: data.page,
      sort: data.sortBy,
      order: data.sortDesc ? 'desc' : 'asc',
      ...payload,
      tgl_awal:
        payload &&
        payload.date_filter &&
        payload.date_filter.length > 0 &&
        payload.date_filter[0]
          ? moment(payload.date_filter[0]).format('YYYY-MM-DD')
          : '',
      tgl_akhir:
        payload &&
        payload.date_filter &&
        payload.date_filter.length > 1 &&
        payload.date_filter[1]
          ? moment(payload.date_filter[1]).format('YYYY-MM-DD')
          : '',
    };

    if (payload && payload.export) {
      let result = await ApiBlobGetRequest(`ijin-karyawan`, params);
      commit('changeIjinKaryawan', {
        loading: false,
      });

      if (result.error) {
        return false;
      } else {
        // The actual download
        var blob = new Blob([result.data], {
          type:
            'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        });
        var link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download = 'report_ijin_karyawan.xlsx';

        document.body.appendChild(link);

        link.click();
        document.body.removeChild(link);

        commit('changeIjinKaryawan', {
          loading: false,
        });

        return true;
      }
    } else {
      let result = await ApiGetRequest(`ijin-karyawan`, params);
      commit('changeIjinKaryawan', {
        items: !result.error ? result.data.object : [],
        total: !result.error ? result.data.total : 0,
        loading: false,
      });

      return !result.error ? true : false;
    }
  },

  async getDetailIjinKaryawan({ commit }, payload = null) {
    commit('changeIjinKaryawan', {
      loading: true,
    });

    let result = await ApiGetRequest(`ijin-karyawan/${payload.id}`);
    commit('changeIjinKaryawan', {
      loading: false,
      detail: result.error ? false : result.data.object,
    });

    return result.error ? false : true;
  },

  async uploadFileIjin({ commit, state }, payload) {
    commit('changeIjinKaryawan', {
      loading: true,
    });

    const { data } = state;
    const result = await ApiPostMultipart(`upload-files`, payload);
    commit('changeIjinKaryawan', {
      loading: false,
    });

    if (!result.error) {
      commit('changeIjinKaryawan', {
        form: {
          ...data.form,
          file_ijin: result.data.object.path,
        },
      });

      return true;
    }

    return false;
  },

  async importData({ commit, dispatch, state }) {
    commit('changeIjinKaryawan', {
      loading: true,
    });

    const { data } = state;
    let result = await ApiPostRequest(`ijin-karyawan/import`, {
      items: data.import_form || [],
    });

    commit('changeIjinKaryawan', {
      loading: false,
    });

    if (!result.error) {
      showNotif(dispatch, {
        message: result.data.message,
      });
    }

    return result.error ? false : true;
  },

  async createIjinKaryawan({ commit, state, dispatch }) {
    commit('changeIjinKaryawan', {
      loading: true,
    });

    let result = await ApiPostRequest(`ijin-karyawan`, state.data.form);
    commit('changeIjinKaryawan', {
      loading: false,
    });

    if (!result.error) {
      showNotif(dispatch, {
        message: result.data.message,
      });
    }

    return result.error ? false : true;
  },

  async updateIjinKaryawan({ commit, state, dispatch }, payload = null) {
    commit('changeIjinKaryawan', {
      loading: true,
    });

    let result = await ApiPutRequest(
      `ijin-karyawan/${payload.id}`,
      state.data.form,
    );

    commit('changeIjinKaryawan', {
      loading: false,
    });

    if (!result.error) {
      showNotif(dispatch, {
        message: result.data.message,
      });
    }

    return result.error ? false : true;
  },

  async deleteIjinKaryawan({ commit, dispatch }, payload = null) {
    commit('changeIjinKaryawan', {
      loading: true,
    });

    let result = await ApiDeleteRequest(`ijin-karyawan/${payload.id}`);
    commit('changeIjinKaryawan', {
      loading: false,
    });

    if (!result.error) {
      showNotif(dispatch, {
        message: result.data.message,
        type: 'success',
      });
    }

    return result.error ? false : true;
  },

  async approveIjinKaryawan({ commit, dispatch }, payload = null) {
    commit('changeIjinKaryawan', {
      loading: true,
    });

    let result = await ApiGetRequest(
      `ijin-karyawan/${payload.id}/${payload.status}`,
    );
    commit('changeIjinKaryawan', {
      loading: false,
    });

    if (!result.error) {
      showNotif(dispatch, {
        message: result.data.message,
        type: 'success',
      });
    }

    return result.error ? false : true;
  },
};
